import z from "zod";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

export const protocolCallRequestEventTypes = ["resolved", "unreachable"] as const;

export const protocolCallRequestEventSchema = z.object({
	type: z.enum(protocolCallRequestEventTypes),
	note: ZodStringNullable,
});

export type ProtocolCallRequestEventFormSchema = z.infer<typeof protocolCallRequestEventSchema>;
